module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7XQMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/~/datatables.net-dt/images/sort_both.png
// module id = ../../../../datatables.net-dt/images/sort_both.png
// module chunks = 2